var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "board-container"
  }, [_c('v-tabs', {
    staticClass: "tab tab--block mb-50 mb-md-70 mb-lg-80"
  }, [_c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.type = '세일즈웍스 코리아';
      }
    }
  }, [_vm._v("세일즈웍스 코리아")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.type = '본사';
      }
    }
  }, [_vm._v("본사")]), _c('v-tab', {
    staticClass: "tab__li",
    on: {
      "click": function click($event) {
        _vm.filter.type = '지점';
      }
    }
  }, [_vm._v("지점")])], 1), _c('div', {
    staticClass: "mb-20"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9",
      "sm": "10",
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 min-w-md-300px",
    attrs: {
      "placeholder": "검색어를 입력하세요.",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return function () {
          _vm.search(true);
        }($event);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3",
      "sm": "2",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "h-100 w-100 w-md-100px color-white",
    attrs: {
      "color": "grey-7"
    },
    on: {
      "click": function click($event) {
        return _vm.search();
      }
    }
  }, [_vm._v("검색")])], 1)], 1)], 1), _c('div', {
    staticClass: "board-list-faq"
  }, [_c('v-expansion-panels', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l(_vm.faqs, function (faq, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', [_c('div', {
      staticClass: "board-list-faq__header"
    }, [_c('div', {
      staticClass: "board-list-faq__header-mark"
    }, [_c('span', {
      staticClass: "helvetica"
    }, [_vm._v("Q")])]), _c('div', {
      staticClass: "board-list-faq__tit"
    }, [_c('span', [_vm._v(_vm._s(faq.subject))])])])]), _c('v-expansion-panel-content', [_c('div', {
      staticClass: "board-list-faq__content"
    }, [_c('div', {
      staticClass: "board-list-faq__content-mark"
    }, [_c('span', {
      staticClass: "helvetica"
    }, [_vm._v("A")])]), _c('div', {
      staticClass: "board-list-faq__txt"
    }, [_c('span', {
      staticClass: "board-list-faq__html",
      domProps: {
        "innerHTML": _vm._s(faq.content.replace(/\n/g, '<br>'))
      }
    })])])])], 1);
  }), 1)], 1), _c('div', {
    staticClass: "mt-50 mt-lg-80"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }